export default __webpack_public_path__ + "static/media/Spinner.c9cb3f17.svg";